module.exports = __webpack_public_path__ + "static/media/0.b480c73a.png";